// 숫자 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import logHelper from './logHelper';

// =================================================================================================
// 상수
// =================================================================================================
// 범위 내 랜덤 정수 겟
const getRandom = (iMin, iMax) => {
  iMin = Math.ceil(iMin);
  iMax = Math.floor(iMax);
  return Math.floor(Math.random() * (iMax - iMin + 1)) + iMin; //최댓값도 포함, 최솟값도 포함
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  getRandom,
};
